export class CoordinatorModel {
    CoordinadorId: number;
    Nombre: string;
    FijoMes: number;
}